module.exports = __webpack_public_path__ + "static/media/privacy-policy-header.bb78a5d0.png";